/** @jsxImportSource @emotion/react */
import React, { Fragment } from 'react';
import { usePlanUsers } from 'api/plan';
import { Box, Theme } from '@mui/material';
import { theme } from 'themes/default';
import { UseStyles } from 'types/styles';
import setSpacing from 'utils/spacing';

const PlanUserList: React.FC<{
  countryId: number;
}> = ({ countryId }) => {
  const classes = useStyles(theme);
  const { data: users, isLoading } = usePlanUsers(new URLSearchParams({ countryId: String(countryId) }));

  if (!users) {
    return null;
  }

  if (isLoading) {
    return null;
  }

  return (
    <Box css={classes.usersListBox}>
      <Box css={classes.usersList}>
        {users.data.map((user, index) => (
          <Fragment key={`members-${user.id}-${index}`}>
            <span css={classes.name}>{user.fullName}</span>
            <span css={classes.email}>{user.email}</span>
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  usersListBox: {
    marginInlineStart: theme.spacing(12),
    background: theme.palette.common.white,
    borderRadius: 8,
    padding: setSpacing([4, 4, 4, 7]),
  },
  usersList: {
    display: 'inline-grid',
    gridTemplateColumns: 'auto auto',
    gap: setSpacing([4, 6]),
  },
  name: {},
  email: {
    color: theme.palette.custom.primary.grey[120],
  },
});

export default PlanUserList;
